import { IGetChecklistServicoLiberacaoByIdUseCase } from "../../../presentation/useCases/read/get_checklist_servico_liberacao_by_id_use_case";
import { ChecklistServicoLiberacao } from "../../models/checklist_servico_liberacao";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetChecklistServicoLiberacaoByIdUseCase
 */

export class GetChecklistServicoLiberacaoByIdUseCase implements IGetChecklistServicoLiberacaoByIdUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(
    idChecklistServicoLiberacao: number,
  ): Promise<ChecklistServicoLiberacao> {
    return await this.repository.getChecklistServicoLiberacaoById(idChecklistServicoLiberacao);
  }
}
